export * from './icons.class';

export * from './icons.service';